export function dictionaryToArray<T>(dict: Record<string | number | symbol, T>): Array<T> {
    return Object.keys(dict).map((key) => dict[key]);
}
